import { createAction, props } from '@ngrx/store';
import { BusinessModel } from '../../models/business.model';

export const enum BusinessActionTypes {
  loadBusinessAction = '[Business] Load Business',
  loadBusinessSuccessAction = '[Business] Load Business Success',
  loadBusinessErrorAction = '[Business] Load Business Error',
  updateImagesSite = '[Business] Update Images Site Success',

  loadEventHistoryTypesAction = '[Activity] Load Event History Types',
  loadEventHistoryTypesSuccessAction = '[Activity] Load Event History Types Success',
  loadEventHistoryTypesErrorAction = '[Activity] Load Event History Types Error',

  updateThemeSuccessAction = '[Business] Updata Website Theme success',
  updateBusinessNFCSuccess = '[PANEL] Updata Business Data NFC success',
}

export const loadBusinessBegin = createAction(
  BusinessActionTypes.loadBusinessAction
);

export const loadBusinessSuccess = createAction(
  BusinessActionTypes.loadBusinessSuccessAction,
  props<{ payload: BusinessModel }>()
);

export const loadBusinessError = createAction(
  BusinessActionTypes.loadBusinessErrorAction,
  props<{ payload: any }>()
);

export const loadEventHistoryTypesBegin = createAction(
  BusinessActionTypes.loadEventHistoryTypesAction
);

export const loadEventHistoryTypesSuccess = createAction(
  BusinessActionTypes.loadEventHistoryTypesSuccessAction,
  props<{ payload: BusinessModel }>()
);

export const loadEventHistoryTypesError = createAction(
  BusinessActionTypes.loadEventHistoryTypesErrorAction,
  props<{ payload: any }>()
);

export const updateBusinessNFCAction = createAction(
  BusinessActionTypes.updateBusinessNFCSuccess
);

export const updateThemeSuccess = createAction(
  BusinessActionTypes.updateThemeSuccessAction,
  props<{ payload: any }>()
);

export const updateImagesSite = createAction(
  BusinessActionTypes.updateImagesSite,
  props<{ payload: any }>()
);
